// SAJAFO — inline "Aanpassen" van de personalisatietekst in het winkelmandje
// (drawer + volledige cart-pagina). Plaatsen als assets/sajafo-cart-personalization-edit.js
// en precies één keer laden (layout/theme.liquid), niet apart per cart-weergave -
// anders lopen de click/keydown-listeners hieronder dubbel.
//
// Identificeert de regel via item.key (uniek en stabiel), niet via een
// regelnummer/index - een eerdere versie deed dat wel en dat bleek de
// verkeerde regel te raken zodra de personalisatie-toeslagregel meedeed,
// omdat Liquid's item.index en de volgorde van /cart.js se items-array niet
// betrouwbaar hetzelfde bleken.

(function () {
  function findContainer(el) {
    return el.closest('[data-se-cart-engrave]');
  }

  function enterEditMode(container) {
    if (!container) return;
    var display = container.querySelector('[data-se-cart-engrave-display]');
    var trigger = container.querySelector('[data-se-cart-engrave-trigger]');
    var form = container.querySelector('[data-se-cart-engrave-form]');
    var input = container.querySelector('[data-se-cart-engrave-input]');
    if (!display || !trigger || !form || !input) return;

    display.hidden = true;
    trigger.hidden = true;
    form.hidden = false;
    input.focus();
    input.select();
  }

  function exitEditMode(container) {
    if (!container) return;
    var display = container.querySelector('[data-se-cart-engrave-display]');
    var trigger = container.querySelector('[data-se-cart-engrave-trigger]');
    var form = container.querySelector('[data-se-cart-engrave-form]');
    if (!display || !trigger || !form) return;

    form.hidden = true;
    display.hidden = false;
    trigger.hidden = false;
  }

  function confirmEdit(container) {
    if (!container) return;
    var input = container.querySelector('[data-se-cart-engrave-input]');
    var display = container.querySelector('[data-se-cart-engrave-display]');
    if (!input || !display) return;

    var newValue = input.value.trim();
    if (newValue === '') {
      input.focus();
      return;
    }

    var lineKey = container.getAttribute('data-se-cart-engrave-key');
    var propertyName = container.getAttribute('data-se-cart-engrave-property');

    // Direct al de nieuwe tekst tonen en het formulier sluiten - de klant
    // hoeft niet te wachten op de server-fetch hieronder, die de volledige,
    // actuele properties ophaalt (zodat een andere kant/eigenschap van
    // dezelfde regel niet verloren gaat) en daarna de echte update stuurt.
    var em = display.querySelector('em');
    if (em) em.textContent = '“' + newValue + '”';
    exitEditMode(container);

    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var lineItem = cart.items.find(function (item) {
          return item.key === lineKey;
        });
        if (!lineItem) return null;

        var properties = Object.assign({}, lineItem.properties);
        properties[propertyName] = newValue;

        return fetch(
          window.routes.cart_change_url,
          Object.assign({}, fetchConfig(), {
            body: JSON.stringify({ id: lineKey, quantity: lineItem.quantity, properties: properties }),
          })
        );
      })
      .then(function (response) {
        return response && response.json();
      })
      .then(function () {
        // Zowel de drawer als de volledige cart-pagina luisteren al naar dit
        // event (cart.js) en herladen dan hun eigen sectie-HTML vanaf de
        // server - zo blijven beide overal consistent, ook als de klant de
        // drawer nog open had staan tijdens het bewerken op de cart-pagina.
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sajafo-cart-personalization-edit' });
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-se-cart-engrave-trigger]');
    if (trigger) {
      enterEditMode(findContainer(trigger));
      return;
    }

    var confirmBtn = event.target.closest('[data-se-cart-engrave-confirm]');
    if (confirmBtn) {
      event.preventDefault();
      confirmEdit(findContainer(confirmBtn));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!event.target.matches || !event.target.matches('[data-se-cart-engrave-input]')) return;
    var container = findContainer(event.target);

    if (event.key === 'Enter') {
      event.preventDefault();
      confirmEdit(container);
    } else if (event.key === 'Escape') {
      exitEditMode(container);
    }
  });
})();
